import {type FC, useEffect, useState} from 'react';
import useCenterStore from '../../store/useCenterStore.ts';
import type {MessageInfo} from './types';
import {Container, PageWrapper, SlideContainer, Table, TableWrapper} from './types/MessagePage.styled.ts';
import callApi from '../../apis/callApi.ts';
import MessageDetailPage from './component/MessageDetailPage.tsx';
import {FocusContext, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import MessageRow from './component/MessageRow.tsx';
import useMessageStore from '../../store/useMessageStore.ts';

const MessagePage: FC = () => {
    const [messageInfoAry, setMessageInfoAry] = useState<Array<MessageInfo>>([]);
    const {currentPage, setCurrentPage, selectedMessage, setSelectedMessage} = useMessageStore();
    const {centerInfo} = useCenterStore();

    const fetchData = async () => {
        const {data} = await callApi().get(`/message/?center_code=${centerInfo?.center_id}`);
        setMessageInfoAry(data);
    };

    useEffect(() => {
        fetchData();
    }, [centerInfo]);

    useEffect(() => {
        setFocus('message');
    }, []);

    const handleRowClick = (message: MessageInfo) => {
        setSelectedMessage(message);
        setCurrentPage('detail');
    };

    const handleBackToList = () => {
        setCurrentPage('list');
        setSelectedMessage(null);
        setFocus(`message-row-${selectedMessage?.id}`);
    };

    const {
        ref: messageListRef,
        focusKey: messageListFocusKey,
        focusSelf: focusMessageList,
    } = useFocusable({
        focusKey: 'message-list-page',
        preferredChildFocusKey: `message-row-${messageInfoAry.length > 0 ? messageInfoAry[0].id : 1}`,
        saveLastFocusedChild: true,
        trackChildren: true,
        isFocusBoundary: true,
    });

    const {ref: messageDetailRef, focusKey: messageDetailFocusKey} = useFocusable({
        focusKey: 'message-detail-page-wrapper',
        preferredChildFocusKey: 'message-detail-page',
        saveLastFocusedChild: true,
        trackChildren: true,
        isFocusBoundary: true,
    });

    useEffect(() => {
        // if (messageInfoAry.length > 0) {
        //     focusMessageList();
        // }
    }, [messageInfoAry, focusMessageList]);

    return (
        <Container>
            <SlideContainer $currentpage={currentPage}>
                <PageWrapper>
                    <FocusContext.Provider value={messageListFocusKey}>
                        <TableWrapper>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>순번</th>
                                        <th>어르신 성함</th>
                                        <th>발신자 명</th>
                                        <th>수신일시</th>
                                        <th>메시지 제목</th>
                                    </tr>
                                </thead>
                                <tbody ref={messageListRef}>
                                    {messageInfoAry.map((msg: MessageInfo, index: number) => (
                                        <MessageRow
                                            key={msg.id}
                                            message={msg}
                                            index={index}
                                            totalCount={messageInfoAry.length}
                                            onRowClick={() => handleRowClick(msg)}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </TableWrapper>
                    </FocusContext.Provider>
                </PageWrapper>
                <PageWrapper>
                    <FocusContext.Provider value={messageDetailFocusKey}>
                        <div ref={messageDetailRef}>
                            {selectedMessage && (
                                <MessageDetailPage messageInfo={selectedMessage} onBackToList={handleBackToList} />
                            )}
                        </div>
                    </FocusContext.Provider>
                </PageWrapper>
            </SlideContainer>
        </Container>
    );
};

export default MessagePage;
